import React from 'react';

/**
 * 用于覆盖Context的高阶组件
 * @author LiangXiao <lexliangxiao_i@didiglobal.com>
 * 
 * @example
 * import { SiderContext } from 'antd/es/layout/Sider'
 * const SiderMixinsContext = MixinsContext(SiderContext)
 * ...
 * <SiderMixinsContext value={{siderCollapsed: false}}>
 *  <Menu>
 *      ...
 *  </Menu>
 * </SiderMixinsContext>
 * 
 * @export
 * @param {import('react').Context} context 需要覆盖的Context实例
 * @return {import('react').Component} 返回一个组件 接受一个参数value 用于覆盖context中对应的值
 */
export default function mixinsContext(Context) {
    if(!Context.Consumer || !Context.Provider) throw new Error("MixinsContext 参数需要为Context实例")
    return ({value, children}) => (
        <Context.Consumer>
            {(context) => (
                <Context.Provider value={{...context, ...value}}>
                    {children}
                </Context.Provider>
            )}
        </Context.Consumer>
    )
}
